import {
    createFileRoute,
    useCanGoBack,
    useNavigate,
    useRouter,
} from '@tanstack/react-router'

import { TemplateDetail } from '@/components/zalo/template-detail'

export const Route = createFileRoute(
    '/_app/_authed/_sidebar/settings/zalo/templates/$id',
)({
    component: TemplateDetailPage,
})

function TemplateDetailPage() {
    const { id } = Route.useParams()
    const router = useRouter()
    const canGoBack = useCanGoBack()
    const navigate = useNavigate()
    // Quay lại danh sách giữ bộ lọc (lịch sử trình duyệt); mở thẳng link thì về danh sách.
    const back = () =>
        canGoBack
            ? router.history.back()
            : void navigate({ to: '/settings/zalo/templates' })
    return <TemplateDetail id={id} onBack={back} />
}
